import Svg, {Path} from 'react-native-svg';
import {Props} from '../SvgProps';

const CalendarArrowRight = ({color = 'black', height = 20, width = 20}: Props) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9 18l6-6-6-6"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default CalendarArrowRight;